import { combineReducers } from 'redux'
import counter from './counter'
import { authentication } from '../_reducers/authentication.reducer';
import { pageSize } from '../_reducers/pageSize.reducer';
import { reducer as toastrReducer } from 'react-redux-toastr'

export default combineReducers({
  counter,
  authentication,
  pageSize,
  toastr: toastrReducer
})
